import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import type {Lead as LeadFragment} from 'nutshell-graphql-types';

import {TwoLineInfo} from './two-line-info';

type Props = {
    lead: LeadFragment;
};

export function LeadOpenedBy(props: Props) {
    const body = (
        <Stack isHorizontal={true} spacing={4} alignItems='center'>
            <Body truncate={{type: 'inline'}}>{props.lead.creator.name}</Body>
            {props.lead.clonedFrom && props.lead.clonedFrom.number && (
                <Body truncate={{type: 'inline'}}>
                    <Link href={props.lead.clonedFrom.htmlUrl}>
                        (Cloned from Lead-{props.lead.clonedFrom.number})
                    </Link>
                </Body>
            )}
        </Stack>
    );

    return <TwoLineInfo header='Opened by' body={body} />;
}
